export const SET_NEXT_STEP = 'SET_NEXT_STEP'
export const SET_BACK_STEP = 'SET_BACK_STEP'
export const SET_RESET_STEP = 'SET_RESET_STEP'